import LoginPage from "components/pages/LoginPage";

/**
 * @name CaptureFirstLoginLoginPage
 * @returns {React.Component}
 * @description Capture component to show the login page without anything filled out
 * for the first time login group
 */
export default function CaptureFirstLoginLoginPage(props) {
    return <LoginPage />
}